/**
 * Champion Review Admin Page
 * Lake Charles Landing Page - Modern Migration
 *
 * Admin interface for reviewing and scoring Champion applications
 * Route: /admin/champion-review
 */
import React from 'react';
import { ChampionApplicationReview } from '../../components/champions/admin/ChampionApplicationReview';

export function ChampionReviewPage() {
  return <ChampionApplicationReview />;
}

export default ChampionReviewPage;
